module.exports = __webpack_public_path__ + "da480572e6da72f059f5706aa00069a9.svg";